// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_btn__W1TTO {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  border-radius: 8px;
  cursor: pointer;
  padding: 12px 22px;
}

.Button_yellow__c6boC {
  background-color: #fd4c0a;
  color: #fff;
  transition: all 0.2s linear;
}
.Button_yellow__c6boC:hover {
  background-color: #fd4c0a;
}

.Button_brown__wLTXs {
  background: #3e3c37;
  color: #fff;
  transition: all 0.2s linear;
}

.Button_grey__ZqTlR {
  background-color: rgba(255, 255, 255, 0.45);
  color: rgba(255, 255, 255, 0.45);
  transition: all 0.2s linear;
}

.Button_in_filter__p-X3W {
  background: #3a2159;
  color: #d8cedf;
}

@media (max-width: 850px) {
  .Button_btn__W1TTO {
    padding: 12px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;ECuEE,eAAA;EACA,gBAAA;EACA,kBAAA;EDtEA,kBAAA;EACA,eAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,2BAAA;AAAF;AAEE;EACE,yBAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,2BAAA;AADF;;AAOA;EACE,2CAAA;EACA,gCAAA;EACA,2BAAA;AAJF;;AAUA;EACE,mBAAA;EACA,cAAA;AAPF;;AASA;EACE;IACE,kBAAA;EANF;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.btn {\n  @include buttonlarge;\n\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 12px 22px;\n}\n\n.yellow {\n  background-color: #fd4c0a;\n  color: #fff;\n  transition: all 0.2s linear;\n\n  &:hover {\n    background-color: #fd4c0a;\n  }\n}\n\n.brown {\n  background: #3e3c37;\n  color: #fff;\n  transition: all 0.2s linear;\n\n  // &:hover {\n  //   background-color: #494711;\n  // }\n}\n.grey {\n  background-color: rgba(255, 255, 255, 0.45);;\n  color: rgba(255, 255, 255, 0.45);\n  transition: all 0.2s linear;\n\n  // &:hover {\n  //   background-color: #494711;\n  // }\n}\n.in_filter {\n  background: #3a2159;\n  color: #d8cedf;\n}\n@media (max-width: 850px) {\n  .btn {\n    padding: 12px 16px;\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Button_btn__W1TTO`,
	"yellow": `Button_yellow__c6boC`,
	"brown": `Button_brown__wLTXs`,
	"grey": `Button_grey__ZqTlR`,
	"in_filter": `Button_in_filter__p-X3W`
};
export default ___CSS_LOADER_EXPORT___;
